'use client';

import { LayoutContainer, TextLink, TextPassage } from '@petsmart-ui/sparky';
import cn from 'classnames';
import { getYear } from 'date-fns';
import type { ReactNode } from 'react';

import { getENV, OneTrustButton } from '@libs/common-next';

import { trackFooterClick } from '../../../analytics';
import type { FooterLink } from '../../../types';

import './legal-bar.scss';

type LegalBarProps = Readonly<{
    beforeLinks?: ReactNode;
    copyrightText: string;
    links: FooterLink[];
    className?: string;
}>;

export function LegalBar({ beforeLinks, copyrightText, links, className }: LegalBarProps) {
    const legalBarClassName = cn('footer-legal-bar', className);

    return (
        <div className={legalBarClassName}>
            <LayoutContainer className="footer-legal-bar__container">
                <TextPassage size="sm" className="footer-legal-bar__copyright">
                    &copy; {getYear(Date.now())} {copyrightText}
                </TextPassage>

                <nav aria-label="Legal links">
                    <ul className="footer-legal-bar__links">
                        {beforeLinks && <li className="footer-legal-bar__link">{beforeLinks}</li>}

                        {links.map(({ url, label, openInNewTab }) => (
                            <li key={url} className="footer-legal-bar__link">
                                <TextLink
                                    className="sparky-c-text-passage--sm footer-legal-bar__link"
                                    variant="secondary"
                                    href={url}
                                    rel={openInNewTab ? 'noopener noreferrer' : undefined}
                                    target={openInNewTab ? '_blank' : undefined}
                                    onClick={() => trackFooterClick({ selection: label, link_url: url })}
                                >
                                    {label}
                                </TextLink>
                            </li>
                        ))}

                        {getENV('NEXT_PUBLIC_LOCALE') === 'en-US' && (
                            <li key={'onetrust-button'}>
                                <OneTrustButton
                                    label={'Your Privacy Choices'}
                                    className="sparky-c-text-passage--sm sparky-u-display-flex footer-legal-bar__onetrust-button"
                                />
                            </li>
                        )}
                    </ul>
                </nav>
            </LayoutContainer>
        </div>
    );
}
